/**
 * MobileTabBar — sticky bottom navigation for the returning-client web PWA.
 *
 * The top app-bar nav hides under 640px (see `.rp-appbar__nav` media query in
 * index.css) which leaves the returning-client mobile user without a way to
 * reach their dossier. This component fills that gap with a native-feeling
 * bottom tab bar shown only on small screens, only for `client-returning`.
 *
 * Chat is a tab too — but it doesn't navigate. Tapping it opens the global
 * ChatDock in place, so the conversation continues without losing whichever
 * page the client was reading.
 */
import { FileText, Home as HomeIcon, MessageSquare } from "lucide-react";
import { NavLink } from "react-router";

import { openDock, useDockOpen } from "./chat";
import { useRoleView } from "./roleView";

export function MobileTabBar() {
  const { view, dossierId } = useRoleView();
  const [dockOpen] = useDockOpen();

  if (view !== "client-returning" || !dossierId) return null;

  return (
    <nav className="rp-tabs" aria-label="Primary">
      <NavLink
        to="/"
        end
        className={({ isActive }) =>
          `rp-tabs__item ${isActive ? "rp-tabs__item--active" : ""}`
        }
      >
        <HomeIcon size={20} strokeWidth={2} />
        <span>Home</span>
      </NavLink>
      <NavLink
        to={`/dossier/${dossierId}`}
        className={({ isActive }) =>
          `rp-tabs__item ${isActive ? "rp-tabs__item--active" : ""}`
        }
      >
        <FileText size={20} strokeWidth={2} />
        <span>Documents</span>
      </NavLink>
      <button
        type="button"
        onClick={() => openDock()}
        className={`rp-tabs__item ${dockOpen ? "rp-tabs__item--active" : ""}`}
        aria-pressed={dockOpen}
      >
        <MessageSquare size={20} strokeWidth={2} />
        <span>Chat</span>
      </button>
    </nav>
  );
}
